import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.292 2.29375C11.473 2.11228 11.7234 2 11.9999 2C12.2879 2 12.5474 2.12172 12.7299 2.31651L16.7091 6.28997C17.0996 6.6805 17.0997 7.31946 16.7091 7.70998C16.3186 8.1005 15.6797 8.1005 15.2891 7.70997L12.9999 5.41747V15C12.9999 15.5523 12.5522 16 11.9999 16C11.4477 16 10.9999 15.5523 10.9999 15V5.41668L8.70997 7.70995C8.31944 8.10047 7.68048 8.10053 7.28996 7.71C6.89944 7.31948 6.89944 6.68052 7.28997 6.29L11.292 2.29375Z M4 15C3.44772 15 3 15.4477 3 16V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16V19H5V16C5 15.4477 4.55228 15 4 15Z"
  }));
});
var ActionsUpload = AbstractIcon.withComponent(Icon);
ActionsUpload.displayName = 'ActionsUpload';
export default ActionsUpload;